/* eslint-disable react/no-multi-comp */
import { replace } from "lodash";

// @ts-ignore
import { Field } from "redux-form/dist/redux-form";
import type { BaseFieldProps, WrappedFieldProps } from "redux-form";

import Input, { type InputProps } from "./Input";
import { generateFieldId, returnFieldState } from "./formMetaHelpers";

interface InputFieldProps extends InputProps, WrappedFieldProps {}

function InputField({
  meta,
  input,
  disabled,
  floating = true,
  fieldProps = {},
  ...restProps
}: InputFieldProps) {

  const id = generateFieldId("input", meta, restProps, input);
  const { isInvalid, isValid } = returnFieldState(meta);

  return (
    <Input
      id={id}
      name={input.name}
      value={input.value}
      floating={floating}
      fieldProps={fieldProps}
      isInvalid={isInvalid}
      isValid={isValid}
      errorMessage={meta.error}
      disabled={meta.submitting || disabled}
      onChange={input.onChange}
      onFocus={input.onFocus}
      onBlur={input.onBlur}
      {...restProps} />
  );
}

type InputFieldHocProps = InputProps & BaseFieldProps & {
  digitsOnly?: boolean;
};

const digitsOnlyNormalizer = (val: string) => replace(val, /\D+/g, "");

function InputFieldHoc({
  digitsOnly,
  ...props
}: InputFieldHocProps) {
  return (
    <Field
      component={InputField}
      {...props}
      {...(digitsOnly ? {
        normalize: digitsOnlyNormalizer
      } : {})} />
  );
}

InputFieldHoc.Input = InputField;

export default InputFieldHoc;
